export default "__VITE_ASSET__BG9vSRoU__"